import ArtsDesigns from "../../resources/ArtDeisgn"

function CardsDesigns() {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 md:gap-2 lg:gap-6 px-3">
            {ArtsDesigns && ArtsDesigns.length > 0 ? ArtsDesigns.map((item) => {
                return (
                    <div className="rounded shadow-lg h-fit p-3">
                        <div className="py-2">
                            <div className="font-bold text-xl mb-2">{item.name}</div>
                            <div className="flex flex-row justify-center">
                                <img src={item.pic} alt="art" className="w-60 md:w-auto"/>
                            </div>
                        </div>
                        <div className="w-72">
                            {item.tags && item.tags.length > 0 ? 
                                item.tags.map((tag) => {
                                   return (<span className="inline-block bg-gray-200 rounded-full px-3 text-xs font-semibold text-gray-700 mr-2 mb-2">#{tag}</span>
                            )}) 
                                : <p>No tags available</p>}
                        </div>
                    </div>
                );
            }) : <p>more Art Works are coming soon</p>}
        </div>
    )
}

export default CardsDesigns;